'use client'

import { useStore } from '@/store'
import { NewsletterPopup } from '@/modals/NewsletterPopup'

export const FreeDownloadSignup = () => {
  const user = useStore(state => state.user)
  if (user) {
    return null
  }

  return (
    <NewsletterPopup trigger="click">
      <img
        src="https://vinc.gumlet.io/pics/easy-magic-tricks/learn-four-tricks.jpg?w=1400&dpr=2"
        alt="Learn magic for free"
        className="rounded-2xl my-4 w-full cursor-pointer"
      />
    </NewsletterPopup>
  )
}
